<template>
  <div>
    <h4 class="title">Контактная информация</h4>
    <span
      class="description"
    >Заполните свое имя и способы связи. Мы их никому не расскажем и не передадим. Важно, что именно так будет выглядеть твой профиль в глазах клиентов</span>
    <Inputs
      class="group"
      type="text"
      placeholder="Имя, фамилия"
      subholder="Имя, фамилия"
      name="name"
      ref="name"
      v-on:input="oninput"
      :value="contacts.name.value"
    ></Inputs>
    <Inputs
      class="group"
      type="tel"
      placeholder="Телефон"
      subholder="Телефон"
      name="phone"
      ref="phone"
      v-on:input="oninput"
      :value="contacts.phone"
      :disabled=true
    ></Inputs>
    <Inputs
      class="group"
      type="text"
      placeholder="Электронная почта"
      subholder="Email"
      name="email"
      ref="email"
      v-on:input="oninput"
      :value="contacts.email"
    ></Inputs>
    <div class="btn-wrap">
      <Buttons class="btn-outline-primary">Заполнить позже</Buttons>
      <router-link to="/profile/step/2/" class="btn btn-primary"><span  >Следующий шаг</span></router-link>
    </div>
  </div>
</template>

<script>
import Inputs from "@/components/basic/Input.vue";
import Inputmask from "inputmask";


export default {
  name: "Step1",
  components: {
    Inputs,
  },
  props: {
    contacts: {}
  },
  methods: {
    oninput: function(val, target) {
      if (target.name === "phone") {
        if (!this.$refs.phone.getInput().inputmask.isComplete()) val = "";
      }
      this.$emit("print", target.name, val);
    },
  },
  mounted: function() {
    this.$refs.phone.setAttr("autocomplete", "off");
    this.$refs.phone.setAttr("pattern", "\\d*");
    this.$refs.phone.setAttr("inputmode", "numeric");

    let im = new Inputmask({
        mask: "+7 999 999 99 99",
        placeholder: "+7 ___ ___ __ __"
      }),
      _inp = this.$refs.phone.getInput();
    im.mask(_inp);
    _inp.focus();
    _inp.blur();
    im = new Inputmask({
      mask: "*{1,20}[.*{1,20}][.*{1,20}][.*{1,20}]@*{1,20}[.*{2,6}][.*{1,2}]"
    });
    _inp = this.$refs.email.getInput();
    im.mask(_inp);
    _inp.focus();
    _inp.blur();
  }
};
</script>

<style lang="scss" scoped>
</style>